import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Calendar, TrendDown, CreditCard } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const METHOD_LABELS = {
  prelevement: 'Prelevement',
  cb: 'CB',
  virement: 'Virement',
  especes: 'Especes',
  cheque: 'Cheque',
};

export const ExpenseForecastWidget = ({ wrapStyle }) => {
  const [forecast, setForecast] = useState([]);

  const fetch = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/expenses/forecast`, { params: { months_ahead: 1 }, withCredentials: true });
      setForecast(res.data.forecast || []);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  if (forecast.length === 0) return null;
  const month = forecast[0];
  const monthLabel = new Date(month.month + '-01').toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });

  return (
    <div style={wrapStyle}>
      <div className="card" data-testid="expense-forecast-widget">
        <div className="card-header" style={{ backgroundColor: '#FFF4E5' }}>
          <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#EF6C00' }}>
            <Calendar size={20} weight="bold" /> Previsions depenses - {monthLabel}
          </h3>
        </div>
        <div style={{ padding: '18px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
            <div className="stat-card"><div className="stat-label" style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '0.8rem' }}><TrendDown size={14} /> Total HT</div><div className="stat-value" style={{ fontSize: '1.3rem' }}>{month.total_ht.toLocaleString('fr-FR')} &euro;</div></div>
            <div className="stat-card"><div className="stat-label" style={{ display: 'flex', gap: '6px', alignItems: 'center', fontSize: '0.8rem' }}><CreditCard size={14} /> Total TTC</div><div className="stat-value" style={{ fontSize: '1.3rem' }}>{month.total_ttc.toLocaleString('fr-FR')} &euro;</div></div>
          </div>
          {month.items.length === 0 ? (
            <p style={{ color: '#5E5F66', textAlign: 'center', fontSize: '0.85rem' }}>Aucune depense recurrente prevue</p>
          ) : (
            <table className="data-table" style={{ fontSize: '0.8rem' }}>
              <thead><tr><th>Description</th><th>Fournisseur</th><th>Paiement</th><th style={{ textAlign: 'right' }}>HT</th><th style={{ textAlign: 'right' }}>TTC</th></tr></thead>
              <tbody>
                {month.items.map(it => (
                  <tr key={it.id}>
                    <td style={{ fontWeight: '600' }}>{it.description}</td>
                    <td style={{ color: '#5E5F66' }}>{it.supplier || '-'}</td>
                    <td>{METHOD_LABELS[it.payment_method] || '-'}</td>
                    <td style={{ textAlign: 'right' }}>{(it.amount_ht || 0).toLocaleString('fr-FR')} &euro;</td>
                    <td style={{ textAlign: 'right', fontWeight: '700' }}>{(it.amount_ttc || 0).toLocaleString('fr-FR')} &euro;</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
